import { render, staticRenderFns } from "./GradingHeader.vue?vue&type=template&id=1ed645b6&scoped=true"
import script from "./GradingHeader.vue?vue&type=script&lang=js"
export * from "./GradingHeader.vue?vue&type=script&lang=js"
import style0 from "./GradingHeader.vue?vue&type=style&index=0&id=1ed645b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed645b6",
  null
  
)

export default component.exports